export default "__VITE_ASSET__lpTEiE1r1SNpLPNwP3j6$w__"